import React, { PropsWithChildren } from 'react';

import classes from './ConfirmWidgetContainer.module.scss';

export const ConfirmWidgetContainer = ({ children }: PropsWithChildren) => {
    return <div className={classes.confirmWidgetContainer}> {children}</div>;
};
